import React from 'react';
import {
  Drawer,
  Box,
  useTheme,
} from '@mui/material';

interface ActionModalProps {
  open: boolean;
  height?: string | number;
  onClose: () => void;
  children: React.ReactNode;
}

const ActionModal: React.FC<ActionModalProps> = ({
  open,
  height = '50vh',
  onClose,
  children,
}) => {
  const theme = useTheme();

  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  return (
    <Drawer
      anchor="right" // 1. Keep it on the right side
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: 380,
          // 2. DETACH FROM TOP
          height: height, // Keep your desired height (or use 'auto')
          top: 'auto',    // This overrides the default top: 0
          bottom: 0,      // Forces it to sit at the bottom

          // 3. Styling adjustments
          // borderTopLeftRadius: 16, // Round the inside corner
          boxShadow: theme.shadows[10],
          backgroundColor: theme.palette.background.default,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          bgcolor: theme.palette.background.paper,
        }}
      >
        {children}
      </Box>
    </Drawer>
  );
};

export default ActionModal;